<template>
  <div>
    <div
      v-if="!hide_title"
      class="v-label v-label--active theme--light text-caption pb-2"
    >
      Select Days
    </div>
    <div class="d-flex">
      <div v-for="(val, indx) in items" :key="`${val}_${indx}`">
        <v-avatar
          class="mr-5 pointer"
          :color="selected_days(val)"
          size="36"
          @click="$emit('update_schedule', indx)"
        >
          <span class="white--text text-caption">{{ config[indx] }}</span>
        </v-avatar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DaysSelector",
  props: { hide_title: String, config: Array, items: String },
  data: function () {
    return {
      currentValue: null,
      currentDuration: null,
      time_duration: "",
    };
  },
  mounted() {},
  methods: {
    selected_days: function (val) {
      return val == 1 ? "primary" : "primaryGrey";
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
div.pointer {
  cursor: pointer;
}
</style>
